import * as types from "../actions/actionTypes";
import createEntityReducer from "./createEntityReducer";

export default createEntityReducer({
  entity: "manufacturer",
  listKey: "manufacturers",
  itemKey: "manufacturer",
  getAll: types.GET_ALL_MANUFACTURERS,
  getAllResponse: types.GET_ALL_MANUFACTURERS_RESPONSE,
  getByIdResponse: types.GET_MANUFACTURER_BY_ID_RESPONSE,
  extra: {
    profile: { type: types.GET_MANUFACTURER_PROFILE_RESPONSE, initial: null },
    dashboard: { type: types.GET_MANUFACTURER_DASHBOARD_RESPONSE, initial: null },
  },
});
